import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.timers";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { addChildWindowToHistory as _addChildWindowToHistory, removeChildWindowFromHistory as _removeChildWindowFromHistory } from '../../lib/store/child-windows/actions';
import { addScrollBlocker as _addScrollBlocker, removeScrollBlocker as _removeScrollBlocker } from '../../lib/store/scroll-blockers/actions';
import { enableAriaAppHider, disableAriaAppHider } from '../../lib/aria-app-hider/aria-app-hider';

var getPathForChildWindow = function getPathForChildWindow(pathname, childWindowId) {
  if (pathname.indexOf('_cw_') !== -1) {
    return "".concat(pathname, "/").concat(childWindowId);
  } else {
    return "".concat(pathname, "/_cw_/").concat(childWindowId);
  }
};

var removeChildWindowFromPath = function removeChildWindowFromPath(pathname, childWindowId) {
  var path = pathname.replace(childWindowId, '');

  if (path.match('_cw_/$')) {
    path = path.replace('/_cw_/', '');
  }

  return path;
};

var ChildWindowHistory = /*#__PURE__*/function (_React$Component) {
  _inherits(ChildWindowHistory, _React$Component);

  var _super = _createSuper(ChildWindowHistory);

  function ChildWindowHistory(props) {
    var _this;

    _classCallCheck(this, ChildWindowHistory);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleLocationChange", function (location) {
      var _this$props = _this.props,
          childWindowId = _this$props.childWindowId,
          closeAction = _this$props.closeAction,
          removeChildWindowFromHistory = _this$props.removeChildWindowFromHistory,
          onFrameworkClose = _this$props.onFrameworkClose;

      if (location.pathname.indexOf(childWindowId) === -1) {
        if (onFrameworkClose) {
          onFrameworkClose();
        }

        removeChildWindowFromHistory(childWindowId, closeAction);
      }
    });

    _this.unlisten = props.history.listen(_this.handleLocationChange);
    return _this;
  }

  _createClass(ChildWindowHistory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          history = _this$props2.history,
          childWindowId = _this$props2.childWindowId,
          childWindowType = _this$props2.childWindowType,
          printable = _this$props2.printable,
          addChildWindowToHistory = _this$props2.addChildWindowToHistory,
          ariaHide = _this$props2.ariaHide,
          addScrollBlocker = _this$props2.addScrollBlocker;
      var updatedLocation = getPathForChildWindow(history.location.pathname, childWindowId);
      history.push(updatedLocation);
      addChildWindowToHistory(childWindowId, childWindowType, printable); // Hide content that shouldn't be seen by screen readers

      enableAriaAppHider(ariaHide);
      addScrollBlocker();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
          history = _this$props3.history,
          childWindowId = _this$props3.childWindowId,
          afterClose = _this$props3.afterClose,
          ariaHide = _this$props3.ariaHide,
          removeScrollBlocker = _this$props3.removeScrollBlocker;
      var pathname = history.location.pathname;
      this.unlisten();

      if (pathname.indexOf(childWindowId) !== -1) {
        history.go(-1);
        history.replace(removeChildWindowFromPath(pathname, childWindowId));
        this.props.removeChildWindowFromHistory(childWindowId);
      }

      setTimeout(function () {
        afterClose();
      }, 10); // Restore content that was hidden from screen readers

      disableAriaAppHider(ariaHide);
      removeScrollBlocker();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          childWindowId = _this$props4.childWindowId,
          topChildWindowId = _this$props4.topChildWindowId,
          children = _this$props4.children;
      var props = {}; // If we're not the top-most child window, set our aria-hidden attribute to true
      // to enable our child window's content from screen readers

      if (topChildWindowId !== childWindowId) {
        props['aria-hidden'] = true;
      }

      return /*#__PURE__*/React.createElement("div", props, children);
    }
  }]);

  return ChildWindowHistory;
}(React.Component);

ChildWindowHistory.propTypes = {
  childWindowId: PropTypes.string.isRequired,
  childWindowType: PropTypes.string.isRequired,
  isOpened: PropTypes.bool,
  closeAction: PropTypes.func,
  afterClose: PropTypes.func,
  ariaHide: PropTypes.array,
  printable: PropTypes.bool
};
ChildWindowHistory.defaultProps = {
  isOpened: false,
  afterClose: function afterClose() {},
  //eslint-disable-line no-empty-function
  ariaHide: ['data-app-container'],
  printable: false
};

var mapStateToProps = function mapStateToProps(_ref) {
  var digitalCore = _ref.digitalCore;
  return {
    topChildWindowId: digitalCore.childWindows.topChildWindowId,
    bottomChildWindowId: digitalCore.childWindows.bottomChildWindowId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addChildWindowToHistory: function addChildWindowToHistory(childWindowId, childWindowType, printable) {
      return dispatch(_addChildWindowToHistory(childWindowId, childWindowType, printable));
    },
    removeChildWindowFromHistory: function removeChildWindowFromHistory(childWindowId, modalCloseAction) {
      return dispatch(_removeChildWindowFromHistory(childWindowId, modalCloseAction));
    },
    addScrollBlocker: function addScrollBlocker() {
      return dispatch(_addScrollBlocker());
    },
    removeScrollBlocker: function removeScrollBlocker() {
      return dispatch(_removeScrollBlocker());
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChildWindowHistory));